/**
 * What a face may be, shared by the fontkit boundary (worker side) and the protocol (both sides) without loading
 * fontkit: the main thread imports this package's entry, which must stay free of it (decision 30: fontkit runs in the
 * layout worker; part 12 log, deep-fix r6).
 */

/** Thrown for bytes that are no single font, a face whose tables the engine can't use, or a face that can't be fetched. */
export class FontLoadError extends Error {
  override readonly name = 'FontLoadError';
}

/** Largest glyph count a face may have: glyph IDs travel as 16-bit numbers. */
export const MAX_GLYPHS = 65_535;
